module.exports = {"SETTINGS_ADMIN_TITLE":"Paramètres Admin"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/settings-admin/settings-admin.fr.json
// module id = /Et2
// module chunks = 0